import styled, { css } from "styled-components";

export const TileBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 49%;
  width: 49%;
  position: absolute;
  overflow: hidden;
  border: 1px solid black;
  transform: ${(props) =>
    `translate(${props.position.x},${props.position.y})`} ${(props) =>
  `rotate(${props.rotate})`};
  background-color: #58595a;
  transition: all 0.1s ease;
  ${(props) =>
    props.bg &&
    css`
      box-shadow: inset 4px 4px 0 0 rgba(0, 0, 0, 0.32);
    `}
    z-index: ${(props) => (props.bg ? "0" : "1")};
    img {
        height: 100%;
        user-select: none;
        cursor: pointer;
    }
`;
